import { useEffect, useRef, useState } from 'react'

interface ExpanableContentProps {
  content: string
  className?: string
  full?: boolean
  title?: string
}

export const ExpanableContent = ({
  title = '',
  content,
  className,
  full = false,
}: ExpanableContentProps) => {
  const [expanable, setExpanable] = useState(false)
  const [isExpanded, setIsExpanded] = useState(true)
  const contentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if ((contentRef.current?.clientHeight || 0) > 300 && !full) {
      setExpanable(true)
      setIsExpanded(false)
    }
  }, [])

  return content ? (
    <div
      className={`container relative w-full border-gray-200 py-5 ${className}`}
    >
      {title && (
        <h2 className='mb-4 text-left text-lg font-semibold text-main'>
          {title}
        </h2>
      )}
      <div
        className={`${
          expanable && !isExpanded ? 'h-80 overflow-hidden' : 'auto'
        } break-words`}
        dangerouslySetInnerHTML={{
          __html: content,
        }}
        ref={contentRef}
      />

      {expanable && (
        <div
          className={`${
            isExpanded ? 'relative pt-2' : 'absolute pt-20'
          } bottom-0 left-0 w-full bg-productDetailInfoReadMore text-center`}
        >
          <button
            className={`mx-auto flex h-12 w-[250px] items-center justify-center rounded-sm border bg-white text-sm text-link ${
              isExpanded ? '' : 'shadow-sm'
            }`}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {!isExpanded ? 'Xem thêm' : 'Thu gọn'}
          </button>
        </div>
      )}
    </div>
  ) : null
}

export default ExpanableContent
